module.exports = __webpack_public_path__ + "img/btn-get.72720759.png";